<template>
  <div class="registration-agreement">
    <div class="container">
      <h1>喜车邦自助洗车店会员注册协议</h1>
      <p>本协议（以下简称“协议”）由您（“会员”）与喜车邦自助洗车站（“洗车站”）之间就会员注册和使用自助洗车服务的相关事项达成，具有法律效力。在您注册成为会员前，请认真阅读以下条款，确保您完全理解并同意本协议的内容。</p>
      
      <h2>一、会员资格</h2>
      <ol>
        <li>会员注册时需提供真实、准确、完整的个人信息（如姓名、联系电话、邮箱地址等）。如信息发生变更，请及时更新。</li>
        <li>会员在注册过程中所提交的个人信息将用于本店提供服务、信息通知、推广营销等用途，具体请参见《隐私政策》。</li>
      </ol>
      
      <h2>二、会员服务</h2>
      <ol>
        <li>注册成为会员后，会员可享受以下服务：
          <ol>
            <li>在喜车邦所有自助洗车站点使用洗车设备；</li>
            <li>享受会员专属优惠活动和折扣；</li>
            <li>定期收到洗车站的优惠通知、活动邀请等信息；</li>
            <li>优先体验新设备、新技术等增值服务。</li>
          </ol>
        </li>
        <li>会员在使用自助洗车服务时，需遵守洗车设备的操作规则与安全注意事项。具体操作指导可参见店内提示或通过官方渠道咨询。</li>
      </ol>
      
      <h2>三、费用与支付</h2>
      <ol>
        <li>喜车邦的自助洗车机的计费方式是根据使用的流量和时间进行收费，按照“一元扣一元”计费。</li>
        <li>注册充值成功后，会员账户内的余额可由用户自由使用。余额消费完毕后，需重新充值。</li>
        <li>喜车邦智能自助洗车站不会提供任何退还或逆向兑换服务。</li>
        <li>特别提示：当您暂停使用自助洗车服务时，请务必点击除结算按钮外的任何按钮进行暂停操作，否则系统会继续扣费。用不完的余额将在您点击结算按钮后自动退回您的洗车账户，下次使用时可直接扫描启动机器。</li>
      </ol>
      
      <h2>四、赠送金说明</h2>
      <ol>
        <li>充值赠送金有效期：充值时赠送的赠送金具有有效期，赠送金的有效期会根据充值金额和当时的活动规则而有所不同。具体有效期请参照充值时的提示和活动规则。</li>
        <li>一般情况下，赠送金有效期为赠送之日起两年内有效，但具体有效期可能会根据不同的充值金额和活动有所调整。</li>
        <li>有效期与充值金额的关联：充值金额的大小与赠送金的有效期有关，具体的赠送金有效期将根据当时的活动规则进行设置。例如，某些活动可能规定：充值100元、150元时，赠送金有效期为一年；充值200元及以上时，赠送金有效期为两年，但这仅为示例，实际有效期请以活动规则为准。</li>
        <li>赠送金的使用限制：赠送金仅限于在本店消费使用，不提供任何退还或逆向兑换服务。</li>
        <li>扣款顺序：洗车消费扣款时，系统会优先扣除会员账户中的余额，余额消耗完后，才会扣除赠送金。</li>
      </ol>
      
      <h2>五、会员账户管理</h2>
      <ol>
        <li>会员账户为个人专用，会员应妥善保管自己的账户信息及密码，不得将账户转借、转让他人。</li>
        <li>如发现账户存在被盗用、泄露等安全问题，会员应立即通知洗车站并协助处理。洗车站将根据实际情况对账户采取冻结、暂停等安全措施。</li>
        <li>会员应确保使用自助洗车设备时，操作行为符合相关法律法规，确保不扰乱设备运行及他人使用。</li>
      </ol>
      
      <h2>六、隐私保护</h2>
      <ol>
        <li>洗车站承诺将依法保护会员的个人隐私信息。会员注册时提供的个人信息仅用于会员管理、服务提供及营销活动等。</li>
        <li>洗车站不会未经会员同意，将会员信息泄露给第三方，除非法律要求或为服务提供所必需。</li>
      </ol>
      
      <h2>七、协议的变更与终止</h2>
      <ol>
        <li>洗车站可根据业务需要对本协议条款进行修改，并通过公众号、短信等方式通知会员。会员在变更后的协议发布后继续使用服务即表示接受修改后的条款。</li>
        <li>会员可以随时终止本协议并注销账户，但注销后会员的所有积分、优惠等权益将不再保留。</li>
        <li>如果会员违反本协议条款，洗车站有权暂停或终止其会员资格。</li>
      </ol>
      
      <h2>八、责任限制</h2>
      <ol>
        <li>对于因不可抗力因素（如自然灾害、网络故障等）导致的服务中断，洗车站不承担任何责任。</li>
        <li>会员因违反本协议条款而引发的争议或法律责任，由会员自行承担。</li>
      </ol>
      
      <h2>九、法律适用与争议解决</h2>
      <ol>
        <li>本协议的订立、执行及解释应适用中华人民共和国的法律。</li>
        <li>因本协议产生的或与本协议有关的争议，双方应友好协商解决；如协商不成，则提交洗车站所在地人民法院诉讼解决。</li>
      </ol>
      
      <h2>十、其他</h2>
      <ol>
        <li>本协议的任何条款无效或不可执行，不影响其他条款的效力。</li>
        <li>本协议自会员注册成功并完成相关操作后生效。</li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegistrationAgreement'
}
</script>

<style lang="less" scoped>
.registration-agreement {
  background-color: #f7f7f7;
  margin: 0;
  padding: 0;
  color: #333;
  
  .container {
    width: 90%;
    max-width: 600px;
    margin: 20px auto;
    background-color: #fff;
    padding: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    line-height: 1.8;
    
    h1 {
      text-align: center;
      font-size: 24px;
      margin-bottom: 20px;
      color: #117aff;
      font-weight: bold;
    }
    
    h2 {
      font-size: 18px;
      color: #117aff;
      margin-top: 20px;
      margin-bottom: 10px;
      font-weight: bold;
      border-bottom: 2px solid #117aff;
      padding-bottom: 5px;
    }
    
    p {
      font-size: 16px;
      margin-bottom: 10px;
    }
    
    ul, ol {
      font-size: 16px;
      color: #555;
      margin: 10px 0;
      padding-left: 20px;
    }
    
    li {
      margin-bottom: 8px;
      line-height: 1.6;
    }
    
    ol {
      list-style-type: decimal;
      padding-left: 20px;
    }
    
    ol li {
      margin-bottom: 8px;
    }
    
    ol ol {
      list-style-type: lower-alpha;
      padding-left: 20px;
      margin: 5px 0;
    }
  }
}

/* 响应式设计 */
@media (max-width: 767px) {
  .registration-agreement {
    .container {
      h1 {
        font-size: 22px;
      }
      
      h2 {
        font-size: 16px;
      }
      
      p, ul, ol {
        font-size: 14px;
      }
    }
  }
}
</style>